module.exports = __webpack_public_path__ + "media/images/front/icon_favorite-313d42087fa424f96eaacb200a69a226.png";